<template>
  <div>
    <canvas ref="gameCanvas" width="1000" height="400" class="game_canvas"></canvas>
    <div v-if="juegoTerminado">
      <span class="game_over">Game Over</span>
      <p v-if="points > 0 && totalPoints < 20" class="desc_game_over">
        Los <strong class="game_over_points">{{ roundedPoints }}</strong> puntos que obtuviste fueron agregados a tu puntaje para redimir productos.
      </p>
      <p v-else-if="totalPoints >= 20" class="desc_game_over">
        Bien hecho, diste lo mejor! (ya alcanzaste el límite de puntos pero puedes continuar jugando).
      </p>
      <p v-else class="desc_game_over">
        No lograste obtener puntos esta vez, pero no te preocupes, puedes volver a intentarlo. ¡A jugar!.
      </p>
      <button @click="reiniciarJuego()" class="restart_game">
        Volver a jugar <span class="fa-solid fa-rotate-right"></span>
      </button>
    </div>
    <div v-if="incrementPoints">
      <span :class="{ 'fade-in-text': incrementPoints }">+ {{ oliPoints }}</span>
    </div>
    <div v-if="DescGame">
      <p class="desc_game">
        <strong>¡Bienvenido al Desafío del Motociclista!</strong><br>
        Tu objetivo es guiar al motociclista a través de una pista llena de obstáculos.<br>
        Salta sobre barreras y recoge diferentes ítems para ganar puntos:<br>
        <strong>Controles:</strong> Usa la tecla Espacio o Flecha Arriba para saltar, y las flechas Derecha e Izquierda para moverte hacia los lados.<br>
        <strong>Evita los obstáculos:</strong> Salta para esquivar las barreras que aparecen frente a ti y mantente atento a los obstáculos que pueden alcanzarte desde atrás.<br>
        <strong>Recoge ítems:</strong><br>
        <strong>Estrellas:</strong> Te otorgan 0.1 puntos.<br>
        <strong>Copas:</strong> Te otorgan 0.2 puntos.<br>
        <strong>Tarros de aceite:</strong> Te otorgan 1 punto.<br>
        <strong>Niveles de dificultad:</strong> A medida que acumules puntos, el juego se volverá más rápido y desafiante,
        los niveles son los siguientes:<br>
        <strong>Principiante:</strong> 0.1 a 4.9 puntos.<br>
        <strong>Intermedio:</strong> 5 a 9.9 puntos.<br>
        <strong>Avanzado:</strong> 10 a 14.9 puntos.<br>
        <bstrong>Leyenda:</bstrong> 15 a 20 puntos.<br>

        <strong>Nota:</strong> A partir de los 20 puntos el usuario seguirá teniendo acceso al juego,
        pero no podrá sumar más puntos.<br>
      </p>
      <button @click="btnStartGame()" class="restart_game">
        Jugar <span class="fa-solid fa-play"></span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import imgBiker from '../../../src/assets/imgsGame/biker.png';
import Reward_1 from '../../../src/assets/imgsGame/star.png';
import Reward_2 from '../../../src/assets/imgsGame/cup.png';
import Reward_3 from '../../../src/assets/imgsGame/oil.png';
import Barrier_1 from '../../../src/assets/imgsGame/barrier_1.png';
import Barrier_2 from '../../../src/assets/imgsGame/barrier_2.png';
import Barrier_3 from '../../../src/assets/imgsGame/barrier_3.png';
import Background from '../../../src/assets/imgsGame/background.jpg';

export default {
  data() {
    return {
      DescGame: false,
      gameLevel: 0,
      points: 0,
      roundedPoints: 0,
      totalPoints: 0,
      velocidadJuego: 1,
      juegoTerminado: false,
      incrementPoints: false,
      oliPoints: null,
      imagenesCargadas: false,
      obstaculoTimer: null,
      obstaculoAtrasTimer: null,
      rewardTimer_1: null,
      rewardTimer_2: null,
      rewardTimer_3: null,
      rewards: [],
      obstaculos: [],
      backgroundX: 0,
      backgroundSpeed: 2,
      imagenBiker: new Image(),
      imagenFondo: new Image(),
      obstacleImages: [],
      rewardImages: [],
      rewardTypes: [
        { id: 1, src: Reward_1, points: 0.1 },
        { id: 2, src: Reward_2, points: 0.2 },
        { id: 3, src: Reward_3, points: 1 }
      ],
      obstacleTypes: [
        { src: Barrier_1 },
        { src: Barrier_2 },
        { src: Barrier_3 }
      ],
      intervalTime: null,
      gameTime: 0
    };
  },
  methods: {
    btnStartGame(){
      axios
      .get('api/get-level')
      .then((res) => {
        if(res.data.cod == 0){
          this.DescGame = false;
          this.totalPoints = res.data.data.points;
          this.gameLevel = res.data.data.level;
          if(this.gameLevel > 0){
            this.cargarTodasLasImagenes().then(() => {
              this.iniciarJuego(this.gameLevel);
            });
          }
        } else {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: res.data.message,
            confirmButtonColor: "#dc3545"
          });
        }
      })
      .catch(() => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
          confirmButtonColor: "#dc3545"
        });
      });
    },
    
    cargarImagen(src, imgProp) {
      return new Promise((resolve, reject) => {
        imgProp.src = src;
        imgProp.onload = () => resolve(imgProp);
        imgProp.onerror = () => {
          console.error("Error al cargar la imagen:", src);
          reject(new Error(`No se pudo cargar la imagen: ${src}`));
        };
      });
    },

    async cargarTodasLasImagenes() {
      try {
        await Promise.all([
          this.cargarImagen(imgBiker, this.imagenBiker),
          this.cargarImagen(Background, this.imagenFondo),
          ...this.obstacleTypes.map(obstacle => {
            const img = new Image();
            obstacle.imageObject = img;
            return this.cargarImagen(obstacle.src, img);
          }),
          ...this.rewardTypes.map(reward => {
            const img = new Image();
            reward.img = img;
            return this.cargarImagen(reward.src, img);
          })
        ]);

        this.rewardTypes.forEach(reward => {
          if (!reward.img || !reward.img.src) {
            console.error("La imagen del aceite no es válida:", reward.src);
          }
        });

        this.imagenesCargadas = true;
      } catch (error) {
        console.error("Error cargando imágenes: ", error);
      }
    },

    iniciarJuego(level) {
      if (!this.imagenesCargadas) {
        console.error("Las imágenes no están cargadas.");
        return;
      }

      const canvas = this.$refs.gameCanvas;
      const ctx = canvas.getContext('2d');
      const sueloY = 400;

      if (!ctx) {
        console.error("No se pudo obtener el contexto 2D");
        return;
      }

      this.actualizarJuego(ctx, canvas, sueloY, this.imagenBiker, this.imagenFondo, level);

      document.addEventListener('visibilitychange', this.manejarCambioVisibilidad);
    },

    actualizarJuego(ctx, canvas, sueloY, imagenBiker, imagenFondo, level) {
      const biker = {
        x: 400,
        y: sueloY - 50,
        baseY: sueloY - 50,
        width: window.innerWidth < 768 ? 150 : 110,
        height: window.innerWidth < 768 ? 150 : 110,
        velocidadY: 0,
        velocidadX: 0,
        gravedad: 0.7,
        salto: -15,
        enSuelo: true,
        anguloRotacion: 0,
        desplazamientoY: 0,
        tiempoRebote: 0,
        reboteActivo: false
      };

      this.obstaculos = [];
      this.rewards = [];

      const saltar = () => {
        if (biker.enSuelo) {
          biker.velocidadY = biker.salto;
          biker.enSuelo = false;
          biker.anguloRotacion = -30;
          biker.reboteActivo = false;
        }
      };

      window.addEventListener('keydown', (event) => {
        if (event.code === 'Space' || event.code === 'ArrowUp') {
          event.preventDefault();
          saltar();
        } else if (event.code === 'ArrowRight' || event.code === 'KeyD') {
          biker.velocidadX = 2;
        } else if (event.code === 'ArrowLeft' || event.code === 'KeyA') {
          biker.velocidadX = -2;
        }
      });

      window.addEventListener('keyup', (event) => {
        if (event.code === 'ArrowRight' || event.code === 'KeyD' || event.code === 'ArrowLeft' || event.code === 'KeyA') {
          biker.velocidadX = 0;
        }
      });

      const generarObstaculo = () => {
        const obstaculoAleatorio = this.obstacleTypes[Math.floor(Math.random() * this.obstacleTypes.length)];
        this.obstaculos.push({
          x: canvas.width,
          y: window.innerWidth < 768 ? sueloY - 75 : sueloY - 55,
          width: window.innerWidth < 768 ? 90 : 60,
          height: window.innerWidth < 768 ? 90 : 60,
          img: obstaculoAleatorio.imageObject
        });
      };

      const generarObstaculoAtras = () => {
        const obstaculoAleatorio = this.obstacleTypes[Math.floor(Math.random() * this.obstacleTypes.length)];
        
        this.obstaculos.push({
          x: -100,
          y: window.innerWidth < 768 ? sueloY - 75 : sueloY - 55,
          width: window.innerWidth < 768 ? 90 : 60,
          height: window.innerWidth < 768 ? 90 : 60,
          img: obstaculoAleatorio.imageObject,
          desdeAtras: true
        });
      };

      const generarReward = (type) => {
        const rewardType = this.rewardTypes.find(r => r.id === type);

        const minX = canvas.width / 2;
        const maxX = canvas.width;
        const posicionXAleatoria = Math.floor(Math.random() * (maxX - minX + 1)) + minX;

        this.rewards.push({
          x: posicionXAleatoria,
          y: window.innerWidth < 768 ? sueloY - 300 : sueloY - 200,
          width: window.innerWidth < 768 ? 75 : 50,
          height: window.innerWidth < 768 ? 75 : 50,
          img: rewardType.img,
          points: rewardType.points
        });
      };

      if (this.obstaculoTimer) clearInterval(this.obstaculoTimer);
      if (this.obstaculoAtrasTimer) clearInterval(this.obstaculoAtrasTimer);
      if (this.rewardTimer_1) clearInterval(this.rewardTimer_1);
      if (this.rewardTimer_2) clearInterval(this.rewardTimer_2);
      if (this.rewardTimer_3) clearInterval(this.rewardTimer_3);

      if(level == 1){
        this.velocidadJuego = 1.5;
        this.obstaculoTimer = setInterval(generarObstaculo, 7000);
        this.rewardTimer_1 = setInterval(() => generarReward(1), 17000); // Generar la estrella cada 17 segundos
        this.rewardTimer_2 = setInterval(() => generarReward(2), 123000); // Generar la copa cada 2 minutos y 3 segundos
        this.rewardTimer_3 = setInterval(() => generarReward(3), 300000); // Generar el tarro de aceite cada 5 minutos
      }
      else if(level == 2){
        this.velocidadJuego = 2;
        this.obstaculoTimer = setInterval(generarObstaculo, 5500);
        this.rewardTimer_1 = setInterval(() => generarReward(1), 37000); // Generar la estrella cada 37 segundos
        this.rewardTimer_2 = setInterval(() => generarReward(2), 153000); // Generar la copa cada 2 minutos y 33 segundos
        this.rewardTimer_3 = setInterval(() => generarReward(3), 347000); // Generar el tarro de aceite cada 5 minutos y 47 segundos
      }
      else if(level == 3){
        this.velocidadJuego = 2.5;
        this.obstaculoTimer = setInterval(generarObstaculo, 4500);
        this.obstaculoAtrasTimer = setInterval(generarObstaculoAtras, 25000);
        this.rewardTimer_1 = setInterval(() => generarReward(1), 52000); // Generar la estrella cada 52 segundos
        this.rewardTimer_2 = setInterval(() => generarReward(2), 183000); // Generar la copa cada 3 minutos y 3 segundos
        this.rewardTimer_3 = setInterval(() => generarReward(3), 375000); // Generar el tarro de aceite cada 6 minutos y 15 segundos
      } else {
        this.velocidadJuego = 3.2;
        this.obstaculoTimer = setInterval(generarObstaculo, 3300);
        this.obstaculoAtrasTimer = setInterval(generarObstaculoAtras, 13200);
        this.rewardTimer_1 = setInterval(() => generarReward(1), 77000); // Generar la estrella cada 1 minuto y 17 segundos
        this.rewardTimer_2 = setInterval(() => generarReward(2), 207000); // Generar la copa cada 3 minutos y 27 segundos
        this.rewardTimer_3 = setInterval(() => generarReward(3), 437000); // Generar el tarro de aceite cada 7 minutos y 17 segundos
      }

      const moverFondo = () => {
        this.backgroundX -= this.backgroundSpeed;
        if (this.backgroundX <= -canvas.width) {
          this.backgroundX = 0;
        }
      };

      this.intervalTime = setInterval(() => {
        this.gameTime++;
      }, 1000);

      const loopJuego = () => {
        if (this.juegoTerminado) return;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        moverFondo();
        ctx.drawImage(imagenFondo, this.backgroundX, 0, canvas.width, canvas.height);
        ctx.drawImage(imagenFondo, this.backgroundX + canvas.width, 0, canvas.width, canvas.height);

        biker.y += biker.velocidadY;
        biker.velocidadY += biker.gravedad;

        biker.x += biker.velocidadX;

        if (biker.x < 0){
          biker.x = 0;
        }
        if (biker.x + biker.width > canvas.width){
          biker.x = canvas.width - biker.width;
        }

        if (!biker.enSuelo && !biker.reboteActivo) {
          biker.tiempoRebote += 0.2;
          biker.desplazamientoY = Math.sin(biker.tiempoRebote) * 5;
        }

        if (biker.y + biker.height >= sueloY) {
          biker.y = sueloY - biker.height;
          biker.velocidadY = 0;
          biker.enSuelo = true;
          biker.anguloRotacion = 0;
          biker.reboteActivo = true;
          biker.baseY = biker.y;
        }

        if (biker.reboteActivo) {
          biker.tiempoRebote += 0.2;
          biker.desplazamientoY = Math.sin(biker.tiempoRebote) * 5;
          biker.y = biker.baseY + biker.desplazamientoY;
          if (Math.abs(biker.desplazamientoY) < 1) {
            biker.reboteActivo = false;
          }
        }

        ctx.save();
        ctx.translate(biker.x + biker.width / 2, biker.y + biker.height / 2);
        ctx.rotate((biker.anguloRotacion * Math.PI) / 180);
        ctx.drawImage(imagenBiker, -biker.width / 2, -biker.height / 2, biker.width, biker.height);
        ctx.restore();

        if(level == 1){
          this.velocidadJuego += 0.0005;
        }
        else if(level == 2){
          this.velocidadJuego += 0.0008;
        }
        else if(level == 3 || level == 4){
          this.velocidadJuego += 0.0012;
        }

        this.obstaculos.forEach((obstaculo, index) => {
          if (obstaculo.desdeAtras) {
            obstaculo.x += this.velocidadJuego * 1.8;
          } else {
            obstaculo.x -= this.velocidadJuego;
          }

          obstaculo.x -= this.velocidadJuego;
          ctx.drawImage(obstaculo.img, obstaculo.x, obstaculo.y, obstaculo.width, obstaculo.height);

          if (
            biker.x < obstaculo.x + obstaculo.width - 20 &&
            biker.x + biker.width > obstaculo.x + 8 &&
            biker.y < obstaculo.y + obstaculo.height &&
            biker.y + biker.height > obstaculo.y
          ) {
            this.juegoTerminado = true;
            clearInterval(this.obstaculoTimer);
            clearInterval(this.obstaculoAtrasTimer);
            clearInterval(this.rewardTimer_1);
            clearInterval(this.rewardTimer_2);
            clearInterval(this.rewardTimer_3);
            if(this.points > 0 && this.totalPoints < 20 || this.gameTime > 0){
              this.$emit('finPartida', this.points, this.gameTime);
            }
          }
        });

        this.rewards.forEach((reward, index) => {
          reward.x -= this.velocidadJuego;
          ctx.drawImage(reward.img, reward.x, reward.y, reward.width, reward.height);

          if (
            biker.x < reward.x + reward.width &&
            biker.x + biker.width > reward.x &&
            biker.y < reward.y + reward.height &&
            biker.y + biker.height > reward.y
          ) {
            this.points += reward.points;
            this.rewards.splice(index, 1);
            this.oliPoints = reward.points;
            this.incrementPoints = true;
            setTimeout(() => {
              this.incrementPoints = false;
            }, 1000);
          }
        });

        const ajustarFuente = (ctx) => {
          const anchoVentana = window.innerWidth;
          let tamañoFuente;
          let xPos, yPos, xPosTotal, yPosTotal, xTime, yTime;

          if (anchoVentana < 768) {
            tamañoFuente = "32px GothamBoldItalic";
            xPos = 20;
            yPos = 50;
            xPosTotal = 500;
            yPosTotal = 50;
            xTime = 500;
            yTime = 50;
          } else {
            tamañoFuente = "22px GothamBoldItalic";
            xPos = 15;
            yPos = 30;
            xPosTotal = 750;
            yPosTotal = 30;
            xTime = 350;
            yTime = 30;
          }
          
          ctx.font = tamañoFuente;
          
          ctx.fillStyle = "White";
          this.roundedPoints = Math.round(this.points * 100) / 100;
          ctx.fillText(`Puntaje: ${this.roundedPoints}`, xPos, yPos);

          // Total de puntos obtenidos jugando (histórico)
          ctx.fillText(`Tú Puntaje total: ${this.totalPoints}`, xPosTotal, yPosTotal);

          // Tiempo de juego
          ctx.fillText(`Tiempo de juego: ${this.gameTime}`, xTime, yTime);
        };
        ajustarFuente(ctx);
      
        requestAnimationFrame(loopJuego);
      };

      loopJuego();
    },

    reiniciarJuego() {
      this.points = 0;
      this.juegoTerminado = false;
      this.velocidadJuego = 1;
      clearInterval(this.intervalTime);
      this.gameTime = 0;

      if (this.obstaculoTimer) clearInterval(this.obstaculoTimer);
      if (this.obstaculoAtrasTimer) clearInterval(this.obstaculoAtrasTimer);
      if (this.rewardTimer_1) clearInterval(this.rewardTimer_1);
      if (this.rewardTimer_2) clearInterval(this.rewardTimer_2);
      if (this.rewardTimer_3) clearInterval(this.rewardTimer_3);

      // Se consulta el nivel antes de reinicar juego
      axios
      .get('api/get-level')
      .then((res) => {
        if(res.data.cod == 0){
          this.totalPoints = res.data.data.points;
          this.gameLevel = res.data.data.level;
        } else {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: res.data.message,
            confirmButtonColor: "#dc3545"
          });
        }
      })
      .catch(() => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
          confirmButtonColor: "#dc3545"
        });
      });

      this.iniciarJuego(this.gameLevel);
    }
  },
  mounted() {
    if(!this.DescGame){
      this.DescGame = true;
    }
  }
};
</script>

<style scoped>
.desc_game {
  position: absolute;
  bottom: 12%;
  width: 100%;
  text-align: start;
  font-size: 18px;
  color: black;
}
.restart_game {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  color: white;
  font-weight: bold;
  background-color: #dc3545;
  border-radius: 100px;
}
.game_over {
  color: #1da5df;
  font-size: 30px;
  font-weight: bold;
  padding: 10px;
  position: absolute;
  bottom: 68%;
}
.desc_game_over {
  position: absolute;
  bottom: 60%;
  width: 100%;
  text-align: center;
  font-size: 18px;
}
.game_over_points{
  color: #dc3545;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 5;
  }
}
.fade-in-text {
  position: absolute;
  top: 20%;
  width: 100%;
  left: 0%;
  font-size: 35px;
  font-weight: bold;
  animation: fadeIn 1s ease-in-out;
}

/* MOBILE */
@media only screen and (max-width: 600px) {
  .game_canvas {
    width: 100%;
    height: 100%;
  }
  .game_over {
    font-size: 18px;
    padding: 10px;
    bottom: 70%;
  }
  .desc_game_over {
    padding: 10px;
  }
  .desc_game_over, .game_over_points {
    font-size: 12px;
    bottom: 48%;
    right: 0%;
  }
  .restart_game {
    padding: 5px 15px;
    font-size: 12px;
  }
}
</style>